import React from "react"
import {
  QueryClient,
  QueryClientProvider,
  QueryCache,
  MutationCache,
} from "@tanstack/react-query"
import { captureException } from "./src/services/exception-logger"

// Backstop for errors that escape the fetch layer (which captures API
// failures itself, and captureException dedupes per error instance): what
// lands here is a JS error thrown inside a queryFn/select/mutation.
const onUnhandledQueryError = (error) => {
  captureException(error, {
    type: "business_logic",
    category: "invalid-state",
    context: { errorSource: "react-query" },
  })
}

const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: onUnhandledQueryError }),
  mutationCache: new MutationCache({ onError: onUnhandledQueryError }),
})

const QueryRootElement = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  )
}

export default QueryRootElement
